import cleanedFilename from '~/util/cleanedFilename';

export default {
  EXTRA_TAG_COUNTER: `${cleanedFilename(__filename)}-extra-tag-counter`,
};
